
<template>
<div>
  <div class="row">
    <div class="col-12">
      <h3 class="my-3"> Orders List </h3>
      <order-list-table />
    </div>
  </div>
</div>

</template>

<script>

import OrderListTable from "@/components/order/OrderListTable.vue"

export default {
  components: {
    OrderListTable,
  },
}
</script>
